var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Markdown, Row, Col, Flex, Icon, Loader } from "./";
import { Button } from "./Button";
import Text from "./Text";
import React, { useState } from 'react';
import { styled, css, mq, uiAssets } from "../utils";
var StyledMarkdown = styled(Markdown)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 1rem;\n\n  ul {\n    margin: 0 0 0 1.2rem;\n  }\n\n  li {\n    padding-top: 0;\n  }\n\n  a {\n    white-space: nowrap;\n  }\n"], ["\n  margin-bottom: 1rem;\n\n  ul {\n    margin: 0 0 0 1.2rem;\n  }\n\n  li {\n    padding-top: 0;\n  }\n\n  a {\n    white-space: nowrap;\n  }\n"])));
var ImageContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n\n  &:after {\n    content: '';\n    display: block;\n    padding-bottom: 100%;\n  }\n\n  & > img {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 50%;\n  }\n"], ["\n  position: relative;\n\n  &:after {\n    content: '';\n    display: block;\n    padding-bottom: 100%;\n  }\n\n  & > img {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 50%;\n  }\n"])));
var QuantityIcon = styled.div(function (_a) {
    var _b = _a.theme, _c = _b.colors, primary = _c.primary, white = _c.white, tertiary = _b.fonts.tertiary, _d = _b.fontSizes, large = _d.large, normal = _d.normal, extraBold = _b.fontWeights.extraBold, radii = _b.radii;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    top: 70%;\n    left: 70%;\n    position: absolute;\n    border-radius: ", "px;\n    border: solid 2px ", ";\n    background-color: ", ";\n    color: ", ";\n    font-family: ", ";\n    font-weight: ", ";\n    text-align: center;\n    ", "\n  "], ["\n    top: 70%;\n    left: 70%;\n    position: absolute;\n    border-radius: ", "px;\n    border: solid 2px ", ";\n    background-color: ", ";\n    color: ", ";\n    font-family: ", ";\n    font-weight: ", ";\n    text-align: center;\n    ", "\n  "])), radii[5], primary, white, primary, tertiary, extraBold, mq({
        fontSize: [normal, large],
        lineHeight: ['1.5rem', '2rem'],
        width: ['1.5rem', '2rem'],
    }));
});
var OfferItemButton = styled(Button)(function (_a) {
    var variant = _a.variant, _b = _a.theme, fontWeights = _b.fontWeights, colors = _b.colors;
    return ({
        '&&': {
            height: '46px',
            display: 'inline-flex',
            alignItems: 'center',
            width: 'min-content',
            boxShadow: '0 2px 7px 0 rgb(0 0 0 / 43%)',
            '&:hover': {
                'svg *': {
                    fill: variant === 'primary' ? colors.secondary : colors.primary,
                    stroke: variant === 'primary' ? colors.secondary : colors.primary,
                },
            },
        },
        fontWeight: fontWeights.bold,
        lineHeight: 'normal',
        '& > svg *': {
            fill: variant === 'primary' ? colors.primary : colors.secondary,
            stroke: variant === 'primary' ? colors.primary : colors.secondary,
        },
    });
});
var Accordion = styled('div')(function (_a) {
    var selected = _a.selected;
    return "\n  height: 6rem;\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 0.5rem;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: linear-gradient(180deg, transparent, ".concat(selected ? '#e2e9f8' : '#ffffff', " 65%);\n  }\n");
});
var ExpandButton = styled(Text)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0rem;\n  right: 0;\n  z-index: 1;\n  text-decoration: underline;\n  cursor: pointer;\n"], ["\n  position: absolute;\n  bottom: 0rem;\n  right: 0;\n  z-index: 1;\n  text-decoration: underline;\n  cursor: pointer;\n"])));
var MarkdownAccordion = function (_a) {
    var children = _a.children, expanded = _a.expanded, selected = _a.selected;
    if (expanded) {
        return React.createElement("div", { style: { position: 'relative', paddingBottom: '0.5rem' } }, children);
    }
    return React.createElement(Accordion, { selected: selected }, children);
};
var CustomOfferItemPreviewV2 = function (_a) {
    var name = _a.name, description = _a.description, shortDescription = _a.shortDescription, _b = _a.image, image = _b === void 0 ? uiAssets('OfferItem/placeholder.jpg') : _b, price = _a.price, priceFormatter = _a.priceFormatter, quantity = _a.quantity, _c = _a.lessInfoLabel, lessInfoLabel = _c === void 0 ? 'ausblenden' : _c, _d = _a.moreInfoLabel, moreInfoLabel = _d === void 0 ? 'mehr Infos' : _d, _e = _a.isEditable, isEditable = _e === void 0 ? true : _e, selected = _a.selected, onSelect = _a.onSelect, selectLabel = _a.selectLabel, selectIcon = _a.selectIcon, _f = _a.deselectLabel, deselectLabel = _f === void 0 ? 'Entfernen' : _f, _g = _a.deselectIcon, deselectIcon = _g === void 0 ? React.createElement(Icon.Minus, null) : _g, onClick = _a.onClick, actionLabel = _a.actionLabel, _h = _a.actionIcon, actionIcon = _h === void 0 ? React.createElement(Icon.Plus, { width: 17, height: 17 }) : _h, id = _a.id, children = _a.children;
    var _j = useState(false), isExpanded = _j[0], setIsExpanded = _j[1];
    var _k = useState(false), loading = _k[0], setLoading = _k[1];
    var priceSign = price >= 0 ? '+' : '-';
    var formattedPrice = priceFormatter ? priceFormatter(Math.abs(price)) : Math.abs(price);
    var handleSelect = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!onSelect) return [3, 4];
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4, Promise.resolve(onSelect())];
                case 2:
                    _b.sent();
                    setLoading(false);
                    if (selected && isExpanded) {
                        setIsExpanded(false);
                    }
                    return [3, 4];
                case 3:
                    _a = _b.sent();
                    return [2, setLoading(false)];
                case 4: return [2];
            }
        });
    }); };
    var handleActionButtonClick = function () {
        onClick && selected && onClick();
    };
    return (React.createElement(React.Fragment, null,
        loading && React.createElement(Loader, { overlay: true }),
        React.createElement(Row, { "data-component": "CustomOfferItemPreviewV2", id: id, backgroundColor: selected ? '#e2ebf7' : undefined, py: "normal", pl: ['small', null, null, 'medium'], pr: ['small', 'medium', null, 'large'], my: "small" },
            React.createElement(Col, { width: [1 / 4, 1 / 6], mr: [1, 'small'], px: 0 }, image && (React.createElement(ImageContainer, null,
                React.createElement("img", { src: "".concat(image, "?width=150&height=150"), alt: name }),
                quantity > 1 ? React.createElement(QuantityIcon, null, quantity) : null))),
            React.createElement(Col, { width: [3 / 4, 5 / 6] },
                React.createElement(Flex, { flexDirection: ['column', 'row'], justifyContent: "space-between", alignItems: ['flex-start', 'center'], mb: "small" },
                    name && (React.createElement(Text, { fontWeight: "bold", fontSize: "medium", letterSpacing: -0.48, mr: 3, mb: [3, 0] }, name)),
                    typeof price === 'number' && (React.createElement(Flex, null,
                        !selected && isEditable && (React.createElement(Text, { fontSize: 25, fontWeight: "bold", letterSpacing: -0.6, opacity: 0.46, lineHeight: "20px", mr: "8px" }, priceSign)),
                        React.createElement(Text, { fontFamily: "secondary", fontSize: 25, fontWeight: "extraBold", letterSpacing: -0.6, opacity: selected || !isEditable ? undefined : 0.46, lineHeight: "30px" }, formattedPrice)))),
                !!description && (React.createElement(MarkdownAccordion, { expanded: isExpanded, selected: selected },
                    React.createElement(StyledMarkdown, { children: description }),
                    React.createElement(ExpandButton, { onClick: function () { return setIsExpanded(function (prevState) { return !prevState; }); } }, isExpanded ? lessInfoLabel : moreInfoLabel))),
                !!shortDescription && React.createElement(Text, { fontWeight: "medium" }, shortDescription),
                children,
                React.createElement(Flex, { mt: "small", flexDirection: ['column', 'row'] }, selected && isEditable ? (React.createElement(React.Fragment, null,
                    onClick && (React.createElement(OfferItemButton, { variant: "secondary", mr: "small", mb: ['small', 0], onClick: handleActionButtonClick },
                        actionIcon,
                        actionLabel)),
                    onSelect && (React.createElement(OfferItemButton, { outline: true, onClick: handleSelect },
                        deselectIcon,
                        deselectLabel)))) : (isEditable && (React.createElement(OfferItemButton, { variant: "secondary", onClick: handleSelect },
                    selectIcon,
                    selectLabel ||
                        "F\u00FCr ".concat(priceSign === '-' ? priceSign : '').concat(formattedPrice, " hinzuf\u00FCgen")))))))));
};
export default CustomOfferItemPreviewV2;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=CustomOfferItemPreviewV2.js.map